// 直销商城下单页面
<template>
    <div>
        <van-nav-bar
            title="下单"
            left-text="返回"
            left-arrow
            @click-left="clickback"/>
        <van-card
            :price="data.advise_price"
            :title="prd_name + (version_name=='标准版'?'':version_name)"
            :thumb="img">
            <div slot="num">
                <van-stepper v-model="data.qty" @change="chgqty"/>
            </div>
            <div slot="tags" class="tags">
                <van-tag mark type="primary">{{ cls_name }}</van-tag>
                <van-tag mark type="primary">{{ cls1_name }}</van-tag>
            </div>
            <div slot="desc">
                <div>{{ brand_name }}</div>
                <div>{{ prd_spc }}</div>
                <div>{{ prd_barcode }}</div>
            </div>
        </van-card>

        <van-cell 
            title="储值卡" 
            :v-if="storeValueCardShow" 
            :value="storeValueCardValue" 
            is-link 
            @click="storeValueCardPickShow=true">
        </van-cell>

        <van-cell 
            title="发送" 
            :value="deliveStyleTitle"
            is-link 
            @click="deliveStyleShow=true">
        </van-cell>

        <!-- <van-cell title="到店安装">
            <template slot="right-icon">
                <van-picker :columns="deliveStyle" @change="chgDeliveStyle" />
                <van-switch v-model="deliveStyle" size="small" @change="chgDeliver"/>
            </template>
        </van-cell> -->

        <van-cell-group v-if="data.deliver_style==0">
            <van-cell title="预约到店提货安装时间" icon="clock-o" />
            <van-cell :title="PlanDateText" is-link @click="showPlanDate=true" />
        </van-cell-group>

        <van-cell-group v-if="data.deliver_style==1">
            <van-cell title="快递地址" icon="clock-o" />
            <van-cell :title="areaname" is-link @click="pickarea" />
            <van-field v-model="data.deliver_address" placeholder="请输入地址" />
        </van-cell-group>

        <van-popup
            v-model="showPlanDate"
            round
            position="bottom"
            style="height: 90%; padding-top: 4px;">
            <van-tree-select
                :items="plandates"
                :active-id.sync="data.plan_time"
                :main-active-index.sync="plandateindex"
                height="55vw"
                @click-item="selPlanDate"/>
        </van-popup>

        <van-action-sheet 
            v-model="storeValueCardPickShow" 
            :actions="storeCardContent" 
            @select="pickStoreValue" />

        <van-action-sheet 
            v-model="deliveStyleShow" 
            :actions="deliveStyleContent" 
            @select="chgDeliver" />

        <pickarea ref="pickarea" @pickData="pickarearesult"/>

        <van-field v-model="data.details" placeholder="请输入备注" />

        <van-submit-bar
            :price=" data.settle_amount * 100"
            :disabled='disiable'
            button-text="提交订单"
            label="支付"
            @submit="onSubmit">
            <span slot="tip" v-if="data.storedvaluecard_amount>0" >
                <van-row>
                    <van-col span="12">总计: {{ data.advise_price * data.qty }}</van-col>
                    <van-col span="12">储值卡支付:{{ data.storedvaluecard_amount }}</van-col>
                </van-row>  
            </span>
        </van-submit-bar>
    </div>
</template>

<script>
import {
    Row,
    Col,
    NavBar,
    Picker,
    Swipe,
    SwipeItem,
    Card,
    Panel,
    CellGroup,
    Cell,
    Field,
    Popup,
    Switch,
    TreeSelect,
    SubmitBar,
    Stepper,
    Toast,
    Loading,
    Radio,
    RadioGroup,
    Tag,
    ActionSheet
} from 'vant'
import { getRangeDate, getCurDate } from '@/utils/dateutils'
import { CurShopInfoApi } from '@/api/market'
import { DirectSellOrderApi } from '@/api/directsell'
import pickarea from '@/view/components/pickarea'
// import wxshare from "@/utils/wxshare"
import { getAvailableStoreCard } from '@/utils/assert'
import { payment } from '@/utils/payment'

export default {
    components: {
        [Row.name]: Row,
        [Col.name]: Col,
        [NavBar.name]: NavBar,
        [Picker.name]: Picker,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Card.name]: Card,
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Field.name]: Field,
        [Switch.name]: Switch,
        [Popup.name]: Popup,
        [TreeSelect.name]: TreeSelect,
        [SubmitBar.name]: SubmitBar,
        [Stepper.name]: Stepper,
        [Loading.name]: Loading,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Tag.name]: Tag,
        [ActionSheet.name]: ActionSheet,
        pickarea
    },
    data() {
        return {
            soure: '',
            loading: false,
            areaname: '录入邮递地址',
            version_name: '',
            cls_name: '',
            cls1_name: '',
            prd_spc: '',
            brand_name: '',
            prd_barcode: '',
            prd_name: '',
            img: null,
            deliveStyleShow: false,
            deliveStyleTitle: '到店安装',
            storeValueCardShow: false, // 是否有储值卡
            storeValueCard: null,   // 储值卡
            storeValueCardValue: 0, // 储值卡总可用值
            storeValueCardPickShow: false, // 是否使用储值卡显示否
            disiable: false,
            data: { // 提交数据
                version: null,
                deliver_style: 0,
                plan_date: this.$moment(getCurDate()).format('YYYY-MM-DD'),
                plan_time: 0,
                deliver_region: null,
                deliver_address: null,
                details: null,
                qty: 1,
                storedvaluecard: null, // 使用的储值卡
                storedvaluecard_amount: 0, // 使用的储值卡金额
                deduction_id: null,
                deduction_amount: 0,
                advise_price: 0, // 销售价格
                settle_amount: 0, // 实付金额
            },
            storeCardContent: [
                { name: '使用', id: 1 },
                { name: '不使用', id: 0 }
            ],
            deliveStyleContent: [
                { name: '到店安装', id: 0 },
                { name: '投递', id: 1 }
            ],
            curshopinfo: {
                city: '',
                area: '',
                address: '',
                contact_name: '',
                contace_mobile: ''
            },
            plandatedays: getRangeDate(7, 'more'),
            plandatetimes: [
                {id: 0, text: '9:00-12:00'},
                {id: 1, text: '13:00-18:00'},
                {id: 2, text: '19:00-21:00'}
            ],
            showPlanDate: false,
            plandates: [],
            plandateindex: 0,
            backurl: '/nt/directsell'
        }
    },
    computed: {
        PlanDateText() {
            return this.data.plan_date + ' ' + this.plandatetimes[this.data.plan_time].text
        }
    },
    mounted: function() { 
        const query = JSON.parse(this.$route.query)
        this.prd_name = query.prd_name
        this.version_name = query.version_name
        this.data.advise_price = query.shop_price
        this.data.qty = query.qty
        this.data.version = query.version_id
        this.brand_name = query.brand_name
        this.cls_name = query.cls_name
        this.cls1_name = query.cls1_name
        this.prd_spc = query.prd_spc
        this.img = query.img

        const store_card = getAvailableStoreCard()
        // console.log('stroe')
        // console.log(store_card)
        // console.log(store_card.amount_available)
        if (store_card !=null && store_card.amount_available != null) {
            this.storeValueCardShow = true
            this.storeValueCard = store_card
            this.storeValueCardValue = store_card.amount_available
            this.data.storedvaluecard = store_card.id
        } 
        this.chgqty(1)
        
        const lst = []
        this.plandatedays.forEach((it) => {
            lst.push({
                id: it.id,
                text: it.name,
                children: this.plandatetimes
            })
        })
        this.plandates = lst
    },
    methods: {
        selPlanDate() {
            this.data.plan_date = this.plandatedays[this.plandateindex].id
            this.showPlanDate = false
        },
        getShopInfo() {
            var that = this
            that.axios.get(CurShopInfoApi).then((ret) => {
                that.curshopinfo = {
                    city: ret.details.city?ret.details.city:'',
                    area: ret.details.area?ret.details.area:'',
                    address: ret.details.address?ret.details.address:'',
                    contact_name: ret.details.contact_name?ret.details.contact_name:'',
                    contace_mobile: ret.details.contace_mobile?ret.details.contace_mobile:''
                }
            })
        },
        onSubmit() {
            var that = this
            that.disiable = true
            that.axios.post(DirectSellOrderApi, that.data).then((ret) => {
                if (ret.flag) {

                    if (that.data.settle_amount > 0) {
                        payment(that, ret.details.id,'order',that.backurl)
                    }
                } else {
                    Toast(ret.info)
                }
            }).catch(function (error) {
                Toast(error)
                that.disiable = false
            })
        },
        // payment(order_id){
        //     wxshare.getJSSDK()
        //     var that = this
        //     const paymentdata = {
        //         "order": order_id
        //     }
        //     that.axios.post(UnifiedDirectSellOrderApi, paymentdata).then((ret) => {
        //         window.wx.ready(function(){
        //             window.wx.chooseWXPay({
        //                 timestamp: ret.timeStamp, 
        //                 // 支付签名随机串，不长于 32 位
        //                 nonceStr: ret.nonceStr, 
        //                 package: ret.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        //                 signType: ret.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        //                 paySign: ret.paySign, // 支付签名
        //             success: function(res) {
        //                 console.log(res)
        //                 console.log('支付成功')
        //                 that.$router.push(that.backurl)
        //             },
        //             fail: function(res) {
        //                 console.log(res)
        //                 console.log('支付失败')
        //             },
        //             complete: function(res) {
        //                 console.log(res, 'complete')
        //             }
        //             })
        //         })
        //     })

        // },
        chgDeliver(itm) {
            switch (itm.id) {
                case 0: // 到店安装
                    this.plan_date = null
                    this.plan_time = null
                    // this.data.deliver_style = itm.id
                    // this.deliveStyleTitle = itm.name
                    break
                case 1: // 投递
                    this.areaname = '录入邮寄地址'
                    this.address = null
                    // this.data.deliver_style = 1
                    break
            }
            this.data.deliver_style = itm.id
            this.deliveStyleTitle = itm.name
            this.deliveStyleShow = false
        },
        chgqty(qty) {
            const totalPrice = this.data.advise_price * qty
            if (this.data.storedvaluecard != null
                && this.storeValueCard !=null 
                && this.storeValueCard.amount_available > 0) {
                // 使用储值卡
                this.data.storedvaluecard = this.storeValueCard.id
                if (this.storeValueCard.amount_available >= totalPrice) {
                    this.data.settle_amount = 0
                    this.data.storedvaluecard_amount = totalPrice
                } else {
                    this.data.settle_amount = totalPrice - this.storeValueCard.amount_available
                    this.data.storedvaluecard_amount = this.storeValueCard.amount_available
                }
            } else {
                // 不使用储值卡
                this.storeValueCardValue = 0
                this.data.storedvaluecard = null
                this.data.storedvaluecard_amount = 0
                this.data.settle_amount= totalPrice
            }
        },
        pickStoreValue(item) {
            switch (item.id) {
                case 0:
                    this.data.storedvaluecard = null
                    // this.data.storedvaluecard_amount= 0
                    this.storeValueCardValue = 0
                    break
                case 1:
                    this.data.storedvaluecard = this.storeValueCard.id
                    this.storeValueCardValue = this.storeValueCard.amount_available
                    break
            }
            this.chgqty(this.data.qty)
            this.storeValueCardPickShow = false
        },
        pickarea() {
            console.log('pickarea')
            this.$refs.pickarea.showDialog(true)
        },
        pickarearesult(data) {
            this.areaname = data.areaName
            this.data.deliver_region = data.areaID
        },
        // chgDeliveStyle(picker, value, index) {
        //     switch (index) {
        //         case 0: // 到店安装
        //             this.plan_date = null
        //             this.plan_time = null
        //             this.data.deliver_style = 0
        //             break
        //         case 1: // 投递
        //             this.areaname = '录入邮寄地址'
        //             this.address = null
        //             this.data.deliver_style = 1
        //             break
        //     }
        // },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(this.backurl)
            }
        }
    }
}
</script>

